export default __webpack_public_path__ + "static/media/alabama.9fb7c6af.jpg";